export default __webpack_public_path__ + "static/media/hackberryKlein.cf84c56e.jpg";